(function ( $ ) {
     $.fn.menuLink = function (options) {
         var settings = $.extend({
            someOption: ""
        }, options);

        var objLink    = $('a.mobilNav');
        var dropdown   = $('.dropdown');
        var nav        = $('.navigation');
        var opened     = false;

        var didScroll;
        var lastScrollTop = 0;
        var delta = 200;

        function _init() {
            $( objLink ).each(function() {
                $( this ).click(function() {
                    console.log('click');
                    if(opened == false){
                        opened = true;
                        _openNavigation();
                    }else{
                        opened = false;
                        _closeNavigation();
                    }
                });
            });
             $('.navigation .links a').click(function(e) {
                 e.preventDefault();
                 $.fn.fullpage.setAllowScrolling(true, 'all');
                 $.fn.fullpage.moveTo($(this).attr('href'), 0);
                 _closeNavigation();
             });
//
        }


        function _closeNavigation(){
            $(nav).removeClass('active');
            //$('body').removeClass('locked');
        }

        function _openNavigation(){
            $(nav).addClass('active');
            //$('body').addClass('locked');
        }

        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$("body").menuLink();
